import $ from 'jquery';
import 'imagemapster'; // hoặc đường dẫn tới file plugin nếu không có npm package

document.addEventListener("DOMContentLoaded", async () => {
    // Close popup when click close button
    const { closePopupBanner } = await import('../components/popup.js');
    closePopupBanner();

    // Initialize map interactions
    const { initMap } = await import('../components/map-oshigoto.js');
    initMap();

    const { initDrawer } = await import('../components/drawer.js');
    initDrawer();
});
